import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyCJ4hdFqn1THHWFCZUGTrcyX59w7AjzPu4",
  authDomain: "tile-sprint-domtigre.firebaseapp.com",
  databaseURL: "https://tile-sprint-domtigre-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "tile-sprint-domtigre",
  storageBucket: "tile-sprint-domtigre.firebasestorage.app",
  messagingSenderId: "54663010650",
  appId: "1:54663010650:web:64f519756e925153d77b63",
  measurementId: "G-BXXSGTMJY9"
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getDatabase(app);